import React from "react";

import { useMutation, useQuery } from "@apollo/client";
import { useRouteMatch } from "react-router-dom";

import RbGrid from "components/RbGrid";
import RbTextField from "components/RbTextField";
import {
  createGenreMutation,
  updateGenreMutation,
  genreQuery,
  genreListQuery,
} from "graphql/genre";
import { createSortByProp } from "utils/sortUtils";

import BaseForm from "./BaseForm";

function GenreForm() {
  const { path } = useRouteMatch();
  const match = useRouteMatch(`${path}/:idParam`);
  const idParam = match?.params?.idParam;

  const { data: { genre } = {} } = useQuery(genreQuery, {
    variables: {
      id: idParam,
    },
    skip: !idParam || idParam === "new",
  });

  const [createRow] = useMutation(createGenreMutation, {
    update(cache, result) {
      const { genreList } = cache.readQuery({ query: genreListQuery });
      const data = {
        genreList: [result.data.createGenre, ...genreList].sort(
          createSortByProp("name")
        ),
      };
      cache.writeQuery({
        query: genreListQuery,
        data,
      });
    },
  });

  const [updateRow] = useMutation(updateGenreMutation);

  return (
    <BaseForm
      row={genre}
      createPromise={createRow}
      updatePromise={updateRow}
      title="genre"
    >
      <RbGrid item xs={12}>
        <RbTextField fieldName="name" label="Name" required />
      </RbGrid>
      <RbGrid item xs={4}>
        <RbTextField fieldName="abbreviation" label="Abbreviation" required />
      </RbGrid>
    </BaseForm>
  );
}

export default React.memo(GenreForm);
